module.exports = "img/flags/TL.6b8115b.png";